import useSWR from "swr";
import { fetcher } from "../config/axiosConfig.ts";
import { useNavigate } from "react-router-dom";

export function useCheckIframe(id, setUrl) {
  const navigate = useNavigate();
  const { data } = useSWR(
    `event-order-ms/ticket/check-payment/order-id/${id}`,
    fetcher,
    {
      refreshInterval: 5000,
      onSuccess: (data) => {
        if (data.body.paymentStatus === "SUCCESS") {
          setUrl("");
          navigate("/success");
        } else if (data.body.paymentStatus === "FAILED") {
          setUrl("");
          navigate("/error");
        }
      },
      onError: () => {
        setUrl("");
        navigate("/error");
      },
    }
  );
  return {
    data,
  };
}
